import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  user: "",
  services: "",
  checkBalance: "",
  walletFundReq: "",
  sessionMsg: "",
  userDecrypted: "",
  refundWalletCahoutData: "",
};

// login reducer functions
const LoginStart = (state) => {
  return {
    ...state,
    isLoading: true,
    user: "",
    error: "",
  };
};

const LoginSuccess = (state, data) => {
  return {
    ...state,
    user: data,
    isLoading: false,
    error: "",
  };
};

const LoginFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

// get active services
const getActiveServicesStart = (state) => {
  return {
    ...state,
    isLoading: true,
    services: "",
    error: "",
  };
};

const getActiveServicesSuccess = (state, data) => {
  return {
    ...state,
    services: data,
    isLoading: false,
    error: "",
  };
};

const getActiveServicesFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

// get check Balance
const checkBalanceStart = (state) => {
  return {
    ...state,
    isLoading: true,
    checkBalance: "",
    error: "",
  };
};

const checkBalanceSuccess = (state, data) => {
  return {
    ...state,
    checkBalance: data,
    isLoading: false,
    error: "",
  };
};

const checkBalanceFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

// wallet Fund Req
const walletFundReqStart = (state) => {
  return {
    ...state,
    isLoading: true,
    walletFundReq: "",
    error: "",
  };
};

const walletFundReqSuccess = (state, data) => {
  return {
    ...state,
    walletFundReq: data,
    isLoading: false,
    error: "",
  };
};

const walletFundReqFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

const sessionTypeSuccess = (state, data) => {
  return {
    ...state,
    sessionMsg: data,
  };
};

const userDecrypted = (state, data) => {
  return {
    ...state,
    error: "",
    isLoading: false,
    userDecrypted: data,
  };
};

const RefundWalletCahoutData = (state, data) => {
  return {
    ...state,
    error: "",
    isLoading: false,
    refundWalletCahoutData: data,
  };
};

//close Remitter Popup

const closeRemitterPopupStart = (state) => {
  return {
    isLoading: "",
    error: "",
    services: "",
    walletFundReq: "",
  };
};

const userReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_START:
      return LoginStart(state);
    case actionTypes.LOGIN_SUCCESS:
      return LoginSuccess(state, action.data);
    case actionTypes.LOGIN_FAIL:
      return LoginFail(state, action.err);
    case actionTypes.GET_ACTIVE_SERVICES_START:
      return getActiveServicesStart(state);
    case actionTypes.GET_ACTIVE_SERVICES_SUCCESS:
      return getActiveServicesSuccess(state, action.data);
    case actionTypes.GET_ACTIVE_SERVICES_FAIL:
      return getActiveServicesFail(state, action.err);
    case actionTypes.GET_CHECK_BALANCE_START:
      return checkBalanceStart(state);
    case actionTypes.GET_CHECK_BALANCE_SUCCESS:
      return checkBalanceSuccess(state, action.data);
    case actionTypes.GET_CHECK_BALANCE_FAIL:
      return checkBalanceFail(state, action.err);
    case actionTypes.WALLET_FUND_REQ_START:
      return walletFundReqStart(state);
    case actionTypes.WALLET_FUND_REQ_SUCCESS:
      return walletFundReqSuccess(state, action.data);
    case actionTypes.WALLET_FUND_REQ_FAIL:
      return walletFundReqFail(state, action.err);
    case actionTypes.SESSION_TYPE_START:
      return sessionTypeSuccess(state, action.data);
    case actionTypes.USER_DATA_START:
      return userDecrypted(state, action.data);
      case actionTypes.REFUND_WALLET_CASHOUT_DATA:
        return RefundWalletCahoutData(state, action.data);
    case actionTypes.CLOSE_REMIITER_POPUP_START:
      return closeRemitterPopupStart(state);

    default:
      return state;
  }
};

export default userReducer;
